
export default function AddAssetsButtonDirective() {
    'ngInject';
    return {
        template: require('./add-assets-button.html'),
        transclude: true,
        restrict: 'E',
        scope: {
            disabled: '='
        }
    };
}
